import {AnimationBaseController, GameApiBase} from "@denishussar/html5-game-engine";
import {Inject} from "@denishussar/html5-game-engine";
import {IAnimationControllerConfiguration} from "@denishussar/html5-game-engine";
import {GameModel} from "../../Models/GameModel";
import {GameLogic} from "../../Logic/GameLogic";
import {SoundConstants} from "../../Constants/SoundConstants";
import {Key, SoundType} from "@denishussar/html5-game-engine";
import {ButtonController, IButtonControllerOptions} from "./ButtonController";
import {AnimationContents} from "../AnimationContents";
import {LocalizationContents} from "../../LocalizationContents";
import Storage from '../../Storage/Storage'
export interface IDropDownMenuControllerOptions {
    onClick: () => void;
    hotKey: string;

}

export class DropDownMenuController  extends AnimationBaseController {
    $model: GameModel;
    storage: Storage = new Storage('Kyykka');
    private _pointerDown: boolean = false;
    private _pointerOver: boolean = false;
    private _pressed: boolean = false;
    private _enabled: boolean = true;
    public selected = false;

    public constructor(@Inject private _options: IDropDownMenuControllerOptions,@Inject private _gameLogic: GameLogic,) {
        super("DropDownMenu");
    }

    protected getConfiguration(): IAnimationControllerConfiguration {

        let keyboard = null;




        if (this._options.hotKey) {
            keyboard = {
                [Key[this._options.hotKey]]: {
                    pressed: () => {
                        if (!this._enabled) {
                            return;
                        }
                        this._pressed = true;
                        this.gotoAndStop("open");
                    },
                    released: () => {
                        if (!this._enabled || !this._pressed) {
                            return;
                        }
                        this._pressed = false;
                        this.gotoAndStop("close");
                        this._options.onClick();
                    },
                    down: () => {
                    },
                }
            }
        }

        return <IAnimationControllerConfiguration>{

            childControllers: {
                RussianButton: {
                    instanceName: "ru_button",
                    view: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () =>{
                            this.changeLanguage("Русский");
                        }
                    }
                },

                EnglishButton: {
                    instanceName: "eng_button",
                    view: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () =>{
                            this.changeLanguage("English");
                        }
                    }
                },
                KarjalanButton: {
                    instanceName: "kar_button",
                    view: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () =>{
                            this.changeLanguage("Karjalan");
                        }
                    }
                },
                /*
                SuomalainenButton: {
                    instanceName: "suo_button",
                    view: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () =>{
                            this.setTextByQuery("selected_language", `Suomalainen`);
                            this.gotoAndStop("close");
                        }
                    }
                },
                */

            },
            onPointerDown: () => {
                if (!this._enabled) {
                    return;
                }
                this._pointerDown = true;
                this.gotoAndStop("open");
            },

            onTap: () => {
                if (!this._enabled) {
                    return;
                }
                this._options.onClick();
            },
            sounds: [
                {
                    id: SoundConstants.BUTTON_CLICK,
                    type: SoundType.SFX
                }
            ],
            keyboard: keyboard
        };
    }


    public disabled() {
        this._enabled = false;
        this._pressed = false;
        this._pointerDown = false;
    }

    public enabled() {
        this._enabled = true;
        this.gotoAndStop("close");
    }


    private changeLanguage(selectLanguage:string): void{
        const language = {"Karjalan":"kr","Русский":"ru","English":"en"};
        this.setTextByQuery("selected_language", `Karjalan`);
        this.gotoAndStop("close");
        this._gameLogic.setLang(language[selectLanguage]);
        this._updateLocale();
    }

    protected onInitialize(): void {
        this._updateLocale();
    }

    private _updateLocale() {
        switch (LocalizationContents.getLanguage()) {
            case "ru":
                this.setTextByQuery("selected_language", `Русский`);
                break;
            case "en":
                this.setTextByQuery("selected_language", `English`);
                break;
            case "kr":
                this.setTextByQuery("selected_language", `Karjalan`);
                break;
            default:
                this.setTextByQuery("selected_language", `English`);
                break;
        }
    }
}

